module.exports = __webpack_public_path__ + "img/thank-you.5c003479.png";